import axios from 'axios';
import { getUserAccount, logout } from 'src/services/ezzyEvents/apiService';
import { UserAccountEntity } from 'src/services/ezzyEvents/apiService/responseModel';

const STORAGE_KEY = 'init-login-flow-state';

class AuthService {
  public user: UserAccountEntity | null = null;

  public getUser() {
    return this.user;
  }

  public setLogInSuccess(token: string) {
    localStorage.setItem(STORAGE_KEY, token);
  }

  public getToken(): string | null {
    return localStorage.getItem(STORAGE_KEY) || null;
  }

  public setSSOLogInSuccess(token: string) {
    localStorage.setItem(STORAGE_KEY + '-sso', token);
  }

  public getSSOToken(): string | null {
    return localStorage.getItem(STORAGE_KEY + '-sso') || null;
  }

  public redirectToHome() {
    let url = window.location.href.toLowerCase();
    const i = url.indexOf('/app');
    localStorage.setItem('referer-path', 'login');
    if (i) {
      url = window.location.href.substr(0, i);
    }
    window.location.replace(url);
  }

  public redirectToSignup(user: any) {
    let url = window.location.href.toLowerCase();
    const i = url.indexOf('login');
    localStorage.setItem('referer-path', 'login');
    if (i) {
      url = window.location.href.substr(0, i) + 'sign-up?sso=true';
    }
    window.location.replace(url);
  }

  public goBack() {
    const returl = localStorage.getItem('ezzy-event-login-returl');
    localStorage.removeItem('ezzy-event-login-requrl');
    localStorage.removeItem('ezzy-event-login-returl');
    window.location.href = returl;
  }

  public async login(): Promise<UserAccountEntity> {
    return new Promise<UserAccountEntity>(async (resolve, reject) => {
      const token = localStorage.getItem(STORAGE_KEY);

      if (token) {
        try {
          axios.defaults.headers['Authorization'] = 'Bearer ' + token;
          const res = await getUserAccount();
          if (res && res.data) {
            this.user = res.data;
            resolve(res.data);
          } else {
            reject('error');
          }
        } catch (ex) {
          console.log(ex);
          reject(ex);
        }
      } else {
        reject('token not found.');
      }
    });
  }

  public logout(): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        const token = localStorage.getItem(STORAGE_KEY);
        // if (axios.defaults.headers) {
        //   axios.defaults.headers['Authorization'] = '';
        // }
        const res = await logout(token);
        localStorage.setItem(STORAGE_KEY, '');
        localStorage.setItem('get_analytics_data', '');
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(STORAGE_KEY + '-sso');
        localStorage.removeItem('get_analytics_data');
        localStorage.removeItem('get_analytics_data');
        resolve(res.data);
      } catch (ex) {
        console.log(ex);
        resolve(false);
      }
    });
  }
}

const oAuth = new AuthService();
export default oAuth;
